'use strict';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

$(document).on('change', '.category_type_select', function (e) {
  const categoryType = $(this).val();
  const _action = '/api/masterdata-html/search/' + categoryType;
  var _this = $(this);
  _this.closest('.row').find('.category_select').prop('disabled', true);
  _this.closest('.row').find('.price_select').prop('disabled', true);
  $.ajax({
    type: 'GET',
    url: _action,
    dataType: 'html',
    success: (res) => {
      const data = JSON.parse(res);
      _this.closest('.row').find('.category_select').html(data.categories).prop('disabled', false);
      _this.closest('.row').find('.price_select').html(data.prices).prop('disabled', false);
    },
    error: (err) => {
      _this.closest('.row').find('.category_select').prop('disabled', false);
      _this.closest('.row').find('.price_select').prop('disabled', false);
      alert('Không thể thực hiện lúc này. Vui lòng thử lại sau.');
    },
  });
});

const carouselSwiperSelector = $('#carousel-swiper');
if (Object.keys(carouselSwiperSelector).length > 0) {
  const carousel_swiper = new bootstrap.Carousel(carouselSwiperSelector, {
    interval: false,
  });

  const carouselThumbsSelector = $('#carousel-thumbs');

  // Handles the carousel thumbnails
  $('[id^=carousel-selector-]').on('click', function () {
    const id_selector = $(this).attr('id');
    const id = parseInt(id_selector.substring(id_selector.lastIndexOf('-') + 1));
    carousel_swiper.to(id);
  });

  // Only display 3 items in nav on mobile.
  if ($(window).width() < 575) {
    $('#carousel-thumbs .row div:nth-child(4)').each(function () {
      const rowBoundary = $(this);
      $('<div class="row gx-3 justify-content-center">')
        .insertAfter(rowBoundary.parent())
        .append(rowBoundary.nextAll().addBack());
    });

    $('#carousel-thumbs .carousel-item .row:nth-child(even)').each(function () {
      const boundary = $(this);
      $('<div class="carousel-item">').insertAfter(boundary.parent()).append(boundary.nextAll().addBack());
    });

    // Hide slide arrows if too few items.
    if ($('#gallery--getting-started .carousel-item').length < 4) {
      $('#carousel-thumbs [class^=carousel-control-]').remove();
    }
  } else {
    // Hide slide arrows if too few items.
    if ($('#gallery--getting-started .carousel-item').length < 7) {
      $('#carousel-thumbs [class^=carousel-control-]').remove();
    }
  }

  // Hide slide arrows if too few items.
  if ($('#carousel-swiper .carousel-item').length < 2) {
    $('#carousel-swiper [class^=carousel-control-]').remove();
  }

  // When the carousel slides, auto update
  carouselSwiperSelector.on('slide.bs.carousel', function (e) {
    const id = parseInt($(e.relatedTarget).attr('data-slide-number'));
    $('[id^=carousel-selector-]').removeClass('selected');
    $('[id=carousel-selector-' + id + ']').addClass('selected');

    const carousel_item = $('[id=carousel-selector-' + id + ']').parents('.carousel-item');
    if (!carousel_item.hasClass('active')) {
      carouselThumbsSelector.find('.carousel-item').removeClass('active');
      carousel_item.addClass('active');
    }
  });
}

const lightbox = new PhotoSwipeLightbox({
  // may select multiple "galleries"
  gallery: '#gallery--getting-started',

  // Elements within gallery (slides)
  children: 'a',

  // Without dynamic import
  pswpModule: PhotoSwipe,
});

if (lightbox) {
  lightbox.init();
}

$(document).on('click', '.btn-contact-me-via-phone', function (e) {
  e.preventDefault();
  if (!$(this).hasClass('copy_text')) {
    const phone = $(this).data('clipboard-text');
    $(this)
      .find('span')
      .text(phone + ' • Sao chép');
    $(this).addClass('copy_text');
    $.get('/statistics/takecare/count/' + $(this).data('slug'));
  }
});

$(document).on('click', '.btn-contact-me-via-phone-sp', function (e) {
  if (!$(this).hasClass('call_me')) {
    const phone = $(this).data('clipboard-text');
    $(this).find('span').text(phone);
    $(this).addClass('call_me');
    $.get('/statistics/takecare/count/' + $(this).data('slug'));
    e.preventDefault();
  }
});

$(document).on('click', '.btn-contact-me-via-email', function (e) {
  $.get('/statistics/takecare/count/' + $(this).data('slug'));
});

$(document).on('click', '.btn-contact-me-via-zalo', function (e) {
  $.get('/statistics/takecare/count/' + $(this).data('slug'));
});

$(document).on('click', '.btn-contact-me-via-sms', function (e) {
  $.get('/statistics/takecare/count/' + $(this).data('slug'));
});

$(document).on('click', '.phone-call', function () {
  const $btn = $(this);
  const phone = $btn.find('.phone-text').text();
  $btn.attr('href', 'tel:' + phone);
});

function convertToLatinh(str) {
  // Convert to combinatorial form
  str = str.normalize('NFD');

  // Delete combination diacritics
  str = str.replace(/[\u0300-\u036f]/g, '');

  // Convert the letter đ/Đ to d/D
  str = str.replace(/[đĐ]/g, (m) => (m === 'đ' ? 'd' : 'D'));

  return str;
}

$(document).on('input', '.search-newsletters-by-addresses', function (e) {
  e.preventDefault();

  $(this).closest('.tab-pane').find('.list-group').children('li').removeClass('d-block').addClass('d-none');

  $(this).closest('.tab-pane').find('.district_name').removeClass('highlight-yellow');

  const keyword = convertToLatinh($(this).val().toLowerCase().replace(/\s+/g, ' '));

  if (!keyword.trim()) {
    $(this).closest('.tab-pane').find('.list-group').children('li').removeClass('d-none').addClass('d-block');

    return;
  }

  const provinceElements = $(this).closest('.tab-pane').find('.province_name');

  const districtElements = $(this).closest('.tab-pane').find('.district_name');

  provinceElements.each((index, provinceElement) => {
    const provinceName = $(provinceElement).text().toLowerCase();
    const provinceNameLatinh = convertToLatinh(provinceName);

    if (provinceName.includes(keyword) || provinceNameLatinh.includes(keyword)) {
      $(provinceElement).closest('li').removeClass('d-none').addClass('d-block');
    }
  });

  districtElements.each((index, districtElement) => {
    const districtName = $(districtElement).text().toLowerCase();
    const districtNameLatinh = convertToLatinh(districtName);

    if (districtName.includes(keyword) || districtNameLatinh.includes(keyword)) {
      $(districtElement).addClass('highlight-yellow');
      $(districtElement).closest('li').removeClass('d-none').addClass('d-block');
    }
  });
});
